import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SidebarLogout() {
  const { t } = useTranslation();

  return (
    <div className="menu">
      <div className="menu-item">
        <Link to="/auth/logout" className="menu-link">
          <div className="menu-icon">
            <i className="fa fa-sign-out-alt"></i>
          </div>
          <div className="menu-text">{t("menu.logout")}</div>
        </Link>
      </div>
    </div>
  );
}
